// These roles need to match the values available in the GraphQL API
// enumeration `RoleName`:
const ROLES = {
  SUPERUSER: 'SUPERUSER',
  ADMINISTRATOR: 'ADMINISTRATOR',
  USER: 'USER',
  OWNER: 'OWNER',
  OEM_MANAGER: 'OEM_MANAGER',
} as const;
export default ROLES;

export const ADMIN_ROLES = [
  ROLES.SUPERUSER,
  ROLES.OEM_MANAGER,
  ROLES.ADMINISTRATOR,
  ROLES.OWNER,
];

export const SUPER_USER_ROLES = [ROLES.SUPERUSER];

export type ComputedRole = (typeof ROLES)[keyof typeof ROLES];
